import {
  GetDoctorCategoryListActionTypes,
  GET_DOCTOR_CATEGORY_LIST_FAIL,
  GET_DOCTOR_CATEGORY_LIST_LOADING,
  GET_DOCTOR_CATEGORY_LIST_SUCCESS,
  GetDoctorCategoryListState,
  GET_DOCTOR_CATEGORY_LIST_UPDATE_API_MSG,
  GET_DOCTOR_CATEGORY_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorCategoryListRes } from "./Model";

const initialStateGetPosts: GetDoctorCategoryListState = {
  loading: false,
  getDoctorCategoryListRes: {} as GetDoctorCategoryListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorCategoryListReducer = (
  state = initialStateGetPosts,
  action: GetDoctorCategoryListActionTypes
): GetDoctorCategoryListState => {
  switch (action.type) {
    case GET_DOCTOR_CATEGORY_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        getDoctorCategoryListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_CATEGORY_LIST_FAIL:
      return {
        ...state,
        getDoctorCategoryListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_CATEGORY_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getDoctorCategoryListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_CATEGORY_LIST_UPDATE_API_RES:
      return {
        ...state,
        getDoctorCategoryListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
